import React from "react";
import PropTypes from 'prop-types';
import { PrimaryButton } from "@myplay/ui";
import I18N from '../../I18N';
import { toTitleCase } from '../../utils/stringManipulations';
import { WHITE } from '../../styles/colors';
import "./ScheduleRecord.scss";

const ScheduleSuccess = ({ onClose, onScheduleMore }) => {
  return (
    <div className="schedule-record__success">
      <span className="schedule-record__success__message">{toTitleCase(I18N.t("SCHEDULE_SUCCESS"))}</span>
      <button className="schedule-record__success__schedule-another" onClick={onScheduleMore}>
        <span>{toTitleCase(I18N.t("SCHEDULE_ANOTHER"))}</span>
      </button>
      <PrimaryButton
        color={WHITE}
        background="transparent"
        showBorder
        onClick={onClose}
      >
        {I18N.t("CLOSE").toUpperCase()}
      </PrimaryButton>
    </div>
  );
};

ScheduleSuccess.propTypes = {
  onClose: PropTypes.func, 
  onScheduleMore: PropTypes.func
};

ScheduleSuccess.defaultProps = {
  onClose: ()=> {}, 
  onScheduleMore: ()=> {}
};

export default ScheduleSuccess;